import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import { i18nChangeLanguage } from '@wangeditor/editor';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import '@wangeditor/editor/dist/css/style.css';

const EditorContainer = styled('div')(({ theme }) => ({
  marginTop: '4px',
  height: '310px',
  width: '383px',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    width: '350px',
  },
}));

const ToolbarStyle = {
  '--w-e-toolbar-bg-color': 'rgba(233, 233, 233, 1)',
  '--w-e-toolbar-active-bg-color': '#fbfbfb',
};

const EditorStyle = {
  fontFamily: 'Raleway',
  height: '255px',
  '--w-e-textarea-bg-color': 'none',
  '--w-e-textarea-slight-color': 'rgba(153, 152, 154, 0.7)',
};

const ErrorMessage = styled('div')({
  fontSize: '12px',
  color: 'red',
  height: '29px',
  paddingTop: '17px',
});

const ErrorMessageEmpty = styled('div')({
  height: '18px',
});

const NoteEditContent = ({ formik }) => {
  i18nChangeLanguage('en');
  const [editor, setEditor] = useState(null);
  const [html, setHtml] = useState('');

  const toolbarConfig = {
    toolbarKeys: [
      'bold',
      'italic',
      'fontSize',
      'underline',
      'bulletedList',
      'numberedList',
      'color',
    ],
  };

  const editorConfig = {
    MENU_CONF: {},
    placeholder: 'Tell everyone what you thought...',
    autoFocus: false,
  };

  editorConfig.MENU_CONF['fontSize'] = {
    fontSizeList: ['16px', '18px', '20px', '24px'],
  };

  useEffect(() => {
    formik.setFieldValue('content', html);
  }, [html]);

  const onChange = (editor) => {
    setHtml(editor.getHtml());
  };
  return (
    <>
      <EditorContainer value={formik.values.content} onChange={formik.handleChange}>
        <Toolbar
          editor={editor}
          defaultConfig={toolbarConfig}
          mode="default"
          style={ToolbarStyle}
        />
        <Editor
          name="content"
          defaultConfig={editorConfig}
          value={html}
          onCreated={setEditor}
          onChange={onChange}
          mode="simple"
          style={EditorStyle}
        />
      </EditorContainer>
      {formik.errors.content && formik.touched.content ? (
        <ErrorMessage>Please enter your content</ErrorMessage>
      ) : (
        <ErrorMessageEmpty />
      )}
    </>
  );
};

export default NoteEditContent;
